<template>
    <div class="tsa-PayRetainDialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <img src="../../assets/images/payRetainDialog-close.png" class="close" @click="giveUp" alt="">
            <div class="discount">
                <img v-if="discount" :src="require('../../assets/images/discount/' + discount + '.png')" alt="">
                <p>24小时内有效</p>
            </div>
            <div class="bthGroup">
                <div class="btn" @click="useCoupons">
                    <p>立即使用</p>
                </div>
                <p class="tip">仅限购买20/50/100/200个时间戳套餐</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            discount: ''
        }
    },
    methods: {
        giveUp () {
            
        },
        useCoupons () {

        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-PayRetainDialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        .mask {
            width: 100%;
            height: 100%;
            background: rgba(0,0,0, 0.74);
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 327px;
            height: 414px;
            background: url('../../assets/images/payRetainDialog-bg.png') no-repeat;
            background-size: 100% auto;
            background-position: top center;
            .close {
                position: absolute;
                right: -40px;
                top: 8px;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
            .discount {
                padding-top: 206px;
                margin-bottom: 26px;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    display: block;
                    width: 129px;
                    height: 70px;
                    margin-bottom: 6px;
                }
                p {
                    font-size: 13px;
                    color: #FF364D;
                    line-height: 22px;
                }
            }
            .bthGroup {
                display: flex;
                flex-direction: column;
                align-items: center;
                .btn {
                    width: 160px;
                    height: 40px;
                    border-radius: 100px;
                    border: 1px solid #FFFFFF;
                    background: linear-gradient(to right, #FF9199, #FF364D);
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-shadow: 0px 4px 10px 0px rgba(242,0,0,0.15);
                    margin-bottom: 5px;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                }
                .tip {
                    font-size: 12px;
                    color: #5573BC;
                    line-height: 22px;
                }
            }
        }
    }
</style>